import React from 'react';
import cn from 'classnames';
import Modal from '@components/Modals';
import styles from './KeyboardShortcuts.module.scss';

import { metaSymbol } from '@support/keyboardHandler';
import { isWindows } from '@support/platform-checks';

function Shortcut({ shortcut }) {
  return (
    <div className={styles.shortcut}>
      <span className={styles.shortcutTitle}>{shortcut.title}</span>

      <span className={styles.shortcutKeys}>
        {shortcut.keys.map((key, i) => {
          if (key === null) {
            return (
              <span key={i} className={`${styles.spacer} text-small`}>
                then
              </span>
            );
          }

          return (
            <span key={i} className={styles.key}>
              {key}
            </span>
          );
        })}
      </span>
    </div>
  );
}

function Group({ data }) {
  return (
    <div className={styles.group}>
      <h4 className={styles.title}>{data.title}</h4>
      <div className={styles.shortcuts}>
        {data.shortcuts.map((shortcut, i) => (
          <Shortcut shortcut={shortcut} key={i} />
        ))}
      </div>
    </div>
  );
}

export default class KeyboardShortcuts extends React.Component {
  state = {
    active: false,
  };

  general = [
    {
      title: 'Command Bar',
      keys: [metaSymbol, 'K'],
    },
    {
      title: 'Save or Submit',
      keys: [metaSymbol, 'Enter'],
    },
    {
      title: 'Go back a page',
      keys: ['Esc'],
    },
    {
      title: 'Open focused item',
      keys: ['Enter'],
    },
    {
      title: 'Move up',
      keys: ['↑'],
    },
    {
      title: 'Move down',
      keys: ['↓'],
    },
    {
      title: 'Edit a Note',
      keys: ['E'],
    },
    {
      title: 'Keyboard shortcuts',
      keys: ['?'],
    },
  ];

  navigation = [
    {
      title: 'Home view',
      keys: ['g', null, 'h'],
    },
    {
      title: 'People view',
      keys: ['g', null, 'p'],
    },
    {
      title: 'Starred view',
      keys: ['g', null, 's'],
    },
    {
      title: 'Jump to Group',
      keys: ['g', null, '1-9'],
    },
    {
      title: 'Create a Person',
      keys: ['p'],
    },
    {
      title: 'Search',
      keys: ['/'],
    },
  ];

  contact = [
    {
      title: 'Star/Unstar',
      keys: ['s'],
    },
    {
      title: 'Contact Person',
      keys: ['c'],
    },
    {
      title: 'Add a Note',
      keys: ['n'],
    },
    {
      title: 'Edit Reconnect cadence',
      keys: ['h'],
    },
    {
      title: 'Add to Group',
      keys: ['L'],
    },
    {
      title: 'Merge Person',
      keys: ['m'],
    },
    {
      title: 'Archive Person',
      keys: ['#'],
    },
  ];

  home = [
    {
      title: 'Dismiss an item',
      keys: ['E'],
    },
  ];

  lists = [
    {
      title: 'Edit Group',
      keys: ['E'],
    },
    {
      title: 'Add People to Group',
      keys: ['A'],
    },
    {
      title: 'Remove People from Group',
      keys: [isWindows() ? 'Backspace' : 'Del'],
    },
  ];

  categories = [
    {
      title: 'General',
      shortcuts: this.general,
    },
    {
      title: 'Navigation',
      shortcuts: this.navigation,
    },
    {
      title: 'Person Actions',
      shortcuts: this.contact,
      nested: [
        {
          title: 'Home View',
          shortcuts: this.home,
        },
        {
          title: 'Group View',
          shortcuts: this.lists,
        },
      ],
    },
  ];

  componentDidMount() {
    window.app.on('shortcuts:open', () => {
      if (this.state.active) {
        return this.handleClose();
      }

      this.setState({ active: true });
    });

    window.app.on('hotkey', (e) => {
      if (this.state.active) {
        return this.handleClose();
      }

      if (e.key === '?') {
        e.preventDefault();
        this.setState({ active: true });
      }
    });
  }

  private handleClose() {
    return this.setState({ active: false });
  }

  render() {
    return (
      <Modal
        className="modal-large"
        isOpen={this.state.active}
        onRequestClose={this.handleClose.bind(this)}
      >
        <div className="modal-header">Keyboard Shortcuts</div>
        <div className={cn(styles.content, 'modal-content-padded')}>
          {this.categories.map((category, i) => (
            <div key={i}>
              <Group data={category} />
              {!category.nested
                ? null
                : category.nested.map((item, i) => <Group data={item} key={i} />)}
            </div>
          ))}
        </div>
      </Modal>
    );
  }
}
